module.exports = __webpack_public_path__ + "media/fidelity/fidelity-hero-2be6d0a0.jpg";